import { render } from "./TemplateNineteen.vue?vue&type=template&id=5c80d66d"
import script from "./TemplateNineteen.vue?vue&type=script&lang=js"
export * from "./TemplateNineteen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__